/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Art_History17Inputs */

const en__field__enum_primarystudyinterest_study_art_history17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Art_History17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art History`)
};

const de__field__enum_primarystudyinterest_study_art_history17 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Art_History17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunstgeschichte`)
};

/**
* | output |
* | --- |
* | "Art History" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Art_History17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_art_history17 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Art_History17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Art_History17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_art_history17(inputs)
	return de__field__enum_primarystudyinterest_study_art_history17(inputs)
});
export { _field__enum_primarystudyinterest_study_art_history17 as "_field__enum_primaryStudyInterest_STUDY_ART_HISTORY" }